<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryHandler="queryHandler" :eventHandler="queryEventHanlder"></swb-query-sort-area>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "label": "交易单号",
                "code": "no",
                "valueType": "String",
                "basic": true
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "客户名称",
                "code": "buyerName",
                "basic": true
            },
            {
                "type": "RadioGroup",
                "valueType": "Integer",
                "label": "交易单类型",
                "code": "tradeVoucherType",
                "dataLabel": "text",
                "dataValue": "code",
                "dataList": [
                    {
                        "code": "1",
                        "text": "普通交易单"
                    },
                    {
                        "code": "2",
                        "text": "合同交易单"
                    }
                ],
                "basic": true,
                "value": 2
            },
            {
                "type": "Text",
                "label": "系统合同编号",
                "code": "contractNo",
                "basic": true,
                "valueType": "String"
            },
            {
                "type": "Text",
                "label": "订单号",
                "code": "orderNo",
                "valueType": "String",
                "hidden": true,
                "basic": true
            },
            {
                "type": "Date2",
                "valueType": "String",
                "label": "创建日期",
                "code": "createTime",
                "basic": true
            },
            {
                "type": "Select",
                "label": "交付完成",
                "code": "deliverFinished",
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "true",
                        "label": "是"
                    },
                    {
                        "value": "false",
                        "label": "否"
                    }
                ]
            },
            {
                "type": "Select",
                "label": "支付完成",
                "code": "payFinished",
                "basic": false,
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "true",
                        "label": "是"
                    },
                    {
                        "value": "false",
                        "label": "否"
                    }
                ]
            },
            {
                "type": "Select",
                "label": "验收完成",
                "code": "checked",
                "dataLabel": "text",
                "dataValue": "code",
                "dataList": [
                    {
                        "code": null,
                        "text": "- 全部 -"
                    },
                    {
                        "code": "true",
                        "text": "是"
                    },
                    {
                        "code": "false",
                        "text": "否"
                    }
                ]
            },
            {
                "type": "Select",
                "label": "发票完成",
                "code": "makeOutFinished",
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "true",
                        "label": "是"
                    },
                    {
                        "value": "false",
                        "label": "否"
                    }
                ]
            }
        ],
        "sortFields": [
            {
                "label": "创建时间",
                "code": "createTime",
                "order": "desc",
                "enabled": true
            }
        ]
    };

    export default {
        name: 'swb-trade-voucher-search',
        desc: '交易单列表搜索',
        props: {
            no: {
                type: String,
                default: null
            },
            tradeVoucherType: {
                type: Number,
                default: null
            },
            contractNo: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                //排序、搜索
                queryConfig: null,
                queryKey: null,
                queryEventHanlder: null
            }
        },
        created: function () {
            this.initQuery();
        },
        methods: {
            //
            initQuery: function () {
                //----------------------搜索排序----------------------------
                //查询排序配置信息
                let queryConfig = Utils.merge({}, searchConfigData);
                //查询回调函数调用上下文对象
                //queryConfig.queryContext = this;
                //
                let queryConfigMap = queryConfig.queryFields.toMap("code");
                if(!Utils.isNoB(this.no)) {
                    let noItem = queryConfigMap['no'];
                    noItem.value = this.no;
                }
                if(!Utils.isNoB(this.tradeVoucherType)) {
                    let tradeVoucherTypeItem = queryConfigMap['tradeVoucherType'];
                    tradeVoucherTypeItem.value = this.tradeVoucherType;
                }
                if(!Utils.isNoB(this.contractNo)) {
                    let contractNoItem = queryConfigMap['contractNo'];
                    contractNoItem.value = this.contractNo;
                }
                //
                this.queryConfig = queryConfig;
                //
                let self = this;
                this.queryEventHanlder = function (itemCode, eventName, itemValue, filterItems) {
                    console.log(itemCode + " @" + eventName + " = " + itemValue);
                    //console.log(filterItems);
                    //模拟代码：当审核状态变为“已审核”时隐藏“包含已删除的”字段，禁用销售金额字段；
                    let queryFields = self.queryConfig.queryFields;
                    if(eventName == 'change') {
                        //
                        if(itemCode == 'tradeVoucherType') {
                            let targetContractNo = queryFields.find(function (field) {
                                return field.code == 'contractNo';
                            });
                            let targetOrderNo = queryFields.find(function (field) {
                                return field.code == 'orderNo';
                            });
                            let tradeVoucherTypeInfo = getEnumInfoWith('tradeVoucherType', 'value', itemValue);
                            if(tradeVoucherTypeInfo.name == 'GeneralVoucher') {
                                targetContractNo.hidden = true;
                                targetOrderNo.hidden = false;
                            } else {
                                targetContractNo.hidden = false;
                                targetOrderNo.hidden = true;
                            }
                            //
                            self.queryConfig = Utils.merge({}, self.queryConfig);
                        }
                    }
                };
            },
            //
            queryHandler(queryModel) {
                //缓存查询条件
                this.$emit('showSearch', queryModel);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/tradeVoucher/TradeVoucherSearch.vue